import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListClientsActions } from "store/ducks/clients";

import { Client } from "interfaces/client";
import { ClientCode } from "interfaces/client-codes";

export function* listClientsRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/clients?${queryString}`);

    const getLabel = (client: Client) => {
      const codes = client.clientCodes
        .map((code: ClientCode) => code.client_code)
        .filter(Boolean)
        .join(", ");

      let defaultLabel = client.company_name;
      
      if (codes) {
        defaultLabel = `${codes} - ${client.company_name || client.trade_name}`;
      } else if (client.client_code) {
        defaultLabel = `${client.client_code} - ${client.company_name || client.trade_name} `;
      }

      return query.withAddress
        ? `${defaultLabel} - ${client.address_city}-${client.address_state}`
        : defaultLabel;
    };

    const comboOptions = data.map((client: Client) => ({
      value: client.id,
      label: getLabel(client),
    }));

    yield put(ListClientsActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListClientsActions.failure(errorMessage));
  }
}
